export default __webpack_public_path__ + "static/media/splunk.091c5f8d.svg";